(function() {
  function init() {
    var elements = document.querySelectorAll('[data-scroll-reveal]');
    if (elements.length === 0) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
        }
      });
    }, { rootMargin: '0px 0px -80px 0px', threshold: 0.1 });
    elements.forEach(function(el) {
      observer.observe(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
